<template>
  <div class="bg-white mx-auto paper-shadow">
    <div
      v-if="!isAutoPrint && isImportant"
      class="mark-important-alert alert alert-info text-center font-weight-bold d-print-none"
      style="border-radius: 0"
      :class="{
        'is-loading is-blurred': isLoading,
        'is-blurred': !user || !user.practice || user.practice.status != 1,
      }"
    >
      {{ $helpers.doctor(model) }} is requesting you
      <b>call {{ model.patient_firstname }} {{ model.patient_lastname }} at {{ model.patient_phone | phone }}</b> and
      schedule an appointment
    </div>
    <div
      v-if="!isAutoPrint && practice && practice.id == DemoId"
      class="mark-important-alert alert alert-warning text-center font-weight-bold d-print-none"
      style="border-radius: 0"
      :class="{
        'is-loading is-blurred': isLoading,
        'is-blurred': !user || !user.practice || user.practice.status != 1,
      }"
    >
      <b>This is a test referral</b> - a copy {{ model.sent_time ? 'has been' : 'will be' }} emailed to
      <b>{{ user.practice.email }}</b>
    </div>
    <top-bar
      v-if="showHeader"
      class="pt-1 flex-shrink-0 pb-0"
      :showUsers="false"
      :hideMenu="true"
      :class="{
        'is-loading is-blurred': isLoading,
        'is-blurred': !user || !user.practice || user.practice.status != 1,
      }"
    />
    <div class="mb-3" :class="[showHeader ? 'px-3 pb-3 pt-0' : 'p-5 px-6']">
      <div class="p-0">
        <!-- <ErrorBoundary> -->
        <div v-if="isLoading" class="loader-container">
          <font-awesome-icon icon="spinner-third" size="3x" spin class="mr-2" /><span class="d-block mt-3"
            >Fetching Referral...</span
          >
        </div>
        <div v-if="!isAvailable">
          <div class="row form-group">
            <div class="col">Referral not found</div>
          </div>
        </div>
        <div
          v-else
          class="referral-container"
          :class="{
            'is-loading is-blurred': isLoading,
            'is-blurred': !user || !user.practice || user.practice.status != 1,
          }"
        >
          <div v-if="practice" class="d-flex align-items-center mb-5 row">
            <div class="logo mr-5 col-12 text-center _col-lg-3">
              <!-- TODO: Custom logos, pull from their favicon website -->
              <img
                v-if="practice.logo"
                :src="practice.logo"
                class="img-fluid"
                style="min-height: 75px; max-height: 100px"
              />
              <img v-else src="@/assets/svg/logo.svg" class="img-fluid" style="width: 128px" />
              <!-- <img src="@/assets/svg/logo.svg" class="img-fluid" style="width: 128px" /> -->
            </div>
            <div class="col mt-4 _mt-lg-0 text-center _text-lg-left" style="font-size: 1.175rem">
              <h1 v-if="!practice.is_logo_only">{{ practice.name }}</h1>
              <span v-if="practice.address">
                <font-awesome-icon icon="map-marker-alt" class="text-primary mr-2" />
                {{ $helpers.address(practice) }}
              </span>
              <span v-if="practice.phone">
                <br />

                <font-awesome-icon icon="phone" class="text-primary mr-2" />
                {{ practice.phone | phone }}
              </span>
            </div>
          </div>
          <div style="font-weight: 500">
            <div class="row mb-3">
              <div class="col text-right">
                {{ moment(model.sent_time || model.created_at).format('LL') }}
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <h6>Referred From</h6>
                <span v-if="from" class="d-block"
                  >{{ $helpers.displayUsername(model.referring_doctor) }}<br />
                  <b
                    class="text-capitalize"
                    v-if="
                      model.referring_doctor &&
                      (from && from.name) !== `${model.referring_doctor.first_name} ${model.referring_doctor.last_name}`
                    "
                    >{{ from && from.name }}</b
                  ></span
                >
              </div>
              <div class="col-12 col-sm-6 mt-5 mt-sm-0">
                <h6>Preferred Doctor</h6>
                {{ model.doctor }}
              </div>
            </div>

            <h6 class="mt-5 referral-section">Patient Info</h6>
            <div class="row">
              <div class="col form-group mb-0">
                <label>Name</label>
                <span class="d-block">{{ model.patient_lastname }}, {{ model.patient_firstname }}</span>
              </div>
              <div class="col form-group mb-0" v-if="model.patient_dob">
                <template>
                  <label>Date of birth</label>
                  <span class="d-block">{{ moment.utc(model.patient_dob).format('l') }}</span></template
                >
              </div>
              <div class="col form-group mb-0" v-if="model.guardian_name">
                <template>
                  <label>Parent/Guardian Name</label>
                  <span class="d-block">{{ model.guardian_name }}</span></template
                >
              </div>
              <div class="col form-group mb-0">
                <label>Phone</label>
                <span class="d-block">{{ model.patient_phone | phone }}</span>
              </div>
            </div>
            <template v-if="showInsurance && model.insurance_information">
              <h6 class="mt-5 referral-section">Insurance</h6>
              <span v-if="model.insurance_information != 'providedbelow'">{{
                insuranceTypes[model.insurance_information]
              }}</span>
              <pro-upsell v-else :orWhen="!model.is_freemium" text="Upgrade for full patient details">
                <div style="">
                  <div class="text-center"></div>
                </div>
                <div class="row">
                  <div class="col form-group mb-0">
                    <label>Network</label>
                    <span class="d-block">{{ model.patient_insurance_network }}</span>
                  </div>
                  <div class="col form-group mb-0" v-if="model.patient_insurance_subscriber">
                    <label>Subscriber Name</label>
                    <span class="d-block">{{ model.patient_insurance_subscriber }}</span>
                  </div>
                  <div class="col form-group mb-0">
                    <label>Subscriber DOB</label>
                    <span class="d-block" v-if="model.patient_insurance_dob">{{
                      moment(model.patient_insurance_dob).format('L')
                    }}</span>
                  </div>
                  <div class="col form-group mb-0">
                    <label>SSN/Membership</label>
                    <div class="d-flex _justify-content-between" v-if="model.patient_insurance_membership">
                      <span :class="{ 'is-blurred': !isInsuranceVisible && model.is_incoming }">{{
                        model.patient_insurance_membership
                      }}</span>
                      <a
                        v-if="!isInsuranceVisible && model.is_incoming"
                        style="_position: absolute; _background: #ffffffbb"
                        href="javascript:void(0)"
                        class="ml-3 font-weight-bolder"
                        @click="isInsuranceVisible = !isInsuranceVisible"
                      >
                        <font-awesome-icon :icon="['far', isInsuranceVisible ? 'eye-slash' : 'eye']" />
                        {{ !isInsuranceVisible ? 'Show' : 'Hide' }}
                      </a>
                    </div>
                  </div>
                </div>
              </pro-upsell>
            </template>

            <div class="row form-group mt-5 referral-section">
              <div class="col-7 col-sm-6">
                <h6 class="referral-section">Reason for Referral</h6>
                <div class="row">
                  <div class="col">
                    {{ modelReasons ? modelReasons.map((kv) => kv.value).join(', ') : 'No reason provided' }}
                  </div>
                </div>
                <template v-if="model.comments">
                  <h6 class="mt-5 referral-section">Comment</h6>
                  <div class="row">
                    <div class="col" style="word-break: break-word">
                      {{ model.comments }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-5 col-sm-6 col-print-5">
                <h6>Teeth</h6>
                <ToothPicker v-model="model.teeth" disabled style="max-width: 500px" :key="tooth_list.join('')" />
                <div
                  v-if="tooth_list.length > 0"
                  class="d-block tooth-number-only"
                  v-html="$helpers.formatToothList(tooth_list)"
                ></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-5 mt-sm-0">
                <h6>Additional Documents</h6>

                <span if v-if="!model.attachments || !model.attachments.length" class="text-muted font-weight-normal"
                  >No attachments have been uploaded</span
                >
                <ul v-else-if="!isUploadEnabled" class="thumbnail-grid">
                  <li v-for="file in model.attachments || []" :key="file.id">
                    <file :file="file" :isReadOnly="true" :hideTags="true" :disableLink="true">
                      <div slot="afterIcon" style="word-break: break-all">
                        {{ file.custom_name || file.name }}
                      </div>
                      <div slot="afterDetails"></div>
                    </file>
                  </li>
                </ul>
                <template v-if="isUploadEnabled">
                  <!-- <internal-files :id="model.patient_internal_id_sender" :referralId="model.id" class="mt-3 pt-3" /> -->
                  <attachments
                    ref="attachments"
                    :referralId="model.id"
                    @uploaded="($event) => $emit('uploaded', $event)"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- </ErrorBoundary> -->
      </div>
    </div>
    <div class="footer d-flex justify-content-between align-items-center">
      <span class="d-none d-print-inline-block"
        >Visit <b>refera.com</b> to view full notes, attachments and insurance information</span
      >
      <div class="spacer"></div>
      <img src="../../assets/svg/powered-by-refera.svg" class="img-fluid" alt="Refera" />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import ToothPicker from '@/components/ToothPicker'
import ErrorBoundary from '@/components/ErrorBoundary'
import InsuranceTypes from '@/constants/insurance-types'
import File from '@/components/files/File'
import TopBar from '@/components/_layout/TopBar'
import { mapState, mapGetters } from 'vuex'
import ProUpsell from '@/components/shared/ProUpsell'
import InternalFiles from '@/components/referrals/integration/InternalFiles'
import Attachments from '../../components/referrals/Attachments.vue'
import { PracticeApi } from '@/services'
import ReferaLogo from '@/assets/svg/logo.svg'
import { ReferralApi } from '../../services'
export default {
  props: {
    referralId: {
      required: false,
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    showInsurance: {
      type: Boolean,
      default: false,
    },
    isAutoPrint: {
      type: Boolean,
      default: true,
    },
    isImportant: {
      type: Boolean,
      default: false,
    },
    isUploadEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ToothPicker,
    ErrorBoundary,
    File,
    TopBar,
    ProUpsell,
    InternalFiles,
    Attachments,
  },
  async created() {},
  async mounted() {
    this.isLoading = true
    if (this.isTour) {
      window.parent.postMessage({ type: 'get-referral', payload: this.id })
      window.addEventListener('message', this.onMessage, false)
    } else if (!this.$store.state.referrals.isLoaded) {
      this.referral = await ReferralApi.get(this.id)
      this.isLoading = false
    } else {
      this.isLoading = false
    }
    this.spawnPrint()
  },
  destory() {
    window.removeEventListener('message', this.onMessage)
  },
  watch: {
    model: function () {
      this.spawnPrint()
    },
  },
  data() {
    return {
      isLoading: true,
      isPrintSpawned: false,
      doctors: [],
      preferred_contact_methods: { any: 'Any', email: 'Email', phone: 'Phone' },
      note: '',
      postedReferral: null,
      isInsuranceVisible: false,
      insuranceTypes: InsuranceTypes,
      referral: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settings', ['PracticeTypes', 'FlatReasons', 'DemoId']),
    id() {
      return this.referralId || this.$route.params.id
    },
    model: function () {
      return this.isLoading
        ? this.$store.getters['tour/mockReferral'](this.$store)
        : this.postedReferral || this.referral || this.$store.getters['referrals/get'](this.id) || {}
    },
    isTour() {
      return this.id?.startsWith?.('tour-') && window.parent
    },
    isAvailable: function () {
      return this.model && Object.keys(this.model).length
    },
    patient_age: function () {
      let age = moment().diff(this.model.patient_dob, 'months'),
        diff = age < 24 ? { y: 0, m: age } : { y: Math.floor(age / 12), m: age % 12 }
      return `${diff.y}y ${diff.m}m` // ignore < 1 mo old and just display 0.
    },
    tooth_list: function () {
      if (!this.model || !this.model.teeth || !this.model.teeth.length) return []
      // provide natural sort for numbers, probably not the most desired solution
      // Deciduous teeth (A,B,C etc) will be ordered within Quandrant (LL, UR etc)
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base',
      })
      let teeth = [].slice.call(this.model.teeth)
      teeth.sort(collator.compare)
      return teeth
    },
    from: function () {
      return this.model.practice
    },
    practice: function () {
      return this.model.to_practice
    },
    referralType() {
      return this.PracticeTypes[this.model.to_practice.specialty]
    },
    referralReasons() {
      if (this.referralType === null) return
      return this.FlatReasons
    },
    exisitingReasonsTags() {
      const reasons = this.referralReasons
      if (!reasons) return
      const keys = Object.keys(reasons)
      return keys.map((key) => ({ key, value: reasons[key] }))
    },
    modelReasons() {
      if (!this.model.reasons.length) return
      const reasons = this.referralReasons
      return (
        reasons &&
        this.model.reasons.map((key) => ({
          key,
          value: key in reasons ? reasons[key] : key,
        }))
      )
    },
  },
  methods: {
    onMessage(e) {
      try {
        const data = e.data
        if (data && data.type == 'referral' && data.payload.id == this.id) {
          this.postedReferral = data.payload
          this.isLoading = false
        }
      } catch (ex) {
        console.error(ex)
        this.$helpers.error('Failed to load referral for print')
      }
    },
    spawnPrint() {
      if (
        !this.isAutoPrint ||
        (this.$route.query && this.$route.query.autoPrint === 'false') ||
        (this.$route.meta && typeof this.$route.meta.autoPrint !== 'undefined' && !this.$route.meta.autoPrint) ||
        this.isPrintSpawned
      )
        return
      this.$nextTick(function () {
        try {
          if (this.model.id > 0) {
            //todo: bug: if attachments havent been download they wont show, fix isnt worth the time at this point
            this.isPrintSpawned = true
            window.print()
          }
        } catch (err) {}
      })
    },
    drop(e) {
      e.preventDefault()
      if (e.dataTransfer) {
        this.$refs.upload.$refs.upload.addDataTransfer(e.dataTransfer)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@-webkit-keyframes alertPulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
  100% {
    opacity: 1;
  }
}
.referral-container {
  transition: 0.5s filter linear;
}
.is-loading {
  animation: alertPulse 1.5s ease-out;
  animation-iteration-count: infinite;
}
.loader-container {
  font-size: 1.25em;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 200px);
  margin: 0 auto;
  width: 250px;
  left: 0;
  right: 0;
  z-index: 9;
  color: var(--gray-color);
}
.circled {
  border: 1px solid #1dacd9;
  border-radius: 2em;
  font-weight: bold;
  background: #ecf7fe;
}
h6 {
  letter-spacing: 0;
  text-transform: uppercase;
  padding-bottom: 0.275rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0.75rem;
}
.footer {
  background: #eff3f3;
  padding: 1rem 3rem;
  color: #345559;
  height: 4.5rem;
  img {
    height: 2rem;
  }
}
.mark-important-alert {
  font-size: 0.85rem;
}
@media (min-width: 962px) {
  .mark-important-alert {
    font-size: 1rem;
  }
  .preview .mark-important-alert {
    font-size: 0.85rem;
  }
}
@media print {
  .col-print-5 {
    flex: 0 0 41.6666666667% !important;
    max-width: 41.6666666667% !important;
  }
  .col-print-7 {
    flex: 0 0 58.3333333333% !important;
    max-width: 58.3333333333% !important;
  }
  .footer {
    position: fixed; /* <-- Key line */
    bottom: 00px;
    left: 0px;
    width: 100%;
  }
  .paper-shadow {
    box-shadow: none;
    border: 0;
  }
}

.preview .form-group label {
  font-size: 0.75rem;
}
</style>
